import { NgModule } from '@angular/core';
import { HomeComponent } from './home.component';
import { SharedProviderModule } from '../shared/shared.module';
import { ToolbarModule } from '../toolbar/toolbar.module';
import { GridsterModule } from 'angular-gridster2';
import { VrgroupModule } from '../custom/vrgroup/vrgroup.module';
import { QmPipesModule } from '../components/qm-pipes/qm-pipes.module';
import { NotificationModule } from '../components/notification/notification.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { MeasurementsModule } from '../measurements/measurements.module';
import { ManagementModule } from '../management/management.module';
import { FormDataModule } from '../form-data/form-data.module';
import { ControlsModule } from './map-controls/controls.module';
import { OverlayPanelModule } from '../components/overlay-panel/overlay-panel.module';
import { ViewSettingsModule } from './view-settings/view-settings.module';
import { ElementInfoModule } from '../element-info/element-info.module';
import { ElementDetailsModule } from '../element-details/element-details.module';
import { VivoModule } from '../vivo/vivo.module';
import { AlarmModule} from '../alarm/alarm.module';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ReminderModule } from '../reminder/reminder.module';
import { MapboxModule } from '../shared/map/mapbox/mapbox.module';
import { GoogleProviderService } from '../shared/google-provider.service';
import { NeveModule } from '~app/custom/neve/neve.module';
import { MapboxService } from '~app/shared/map/mapbox/mapbox.service';
import { MapService } from '~app/shared/map/map.service';
import { JoensuuModule } from '~app/custom/joensuu/joensuu.module';

@NgModule({
  imports: [
    ElementInfoModule,
    ElementDetailsModule,
    OverlayPanelModule,
    ControlsModule,
    MapboxModule,
    DashboardModule,
    VrgroupModule,
    MeasurementsModule,
    ManagementModule,
    FormDataModule,
    QmPipesModule,
    NgbTooltipModule,
    SharedProviderModule,
    NotificationModule,
    GridsterModule,
    ToolbarModule,
    ViewSettingsModule,
    VivoModule,
    AlarmModule,
    ReminderModule,
    NeveModule,
    JoensuuModule
  ],
  declarations: [HomeComponent],
  providers: [
    { provide: MapService, useClass: MapboxService },
    GoogleProviderService
  ]
})
export class HomeModule {
}
